/**
 * Global Modal Logic
 */
export default function initGlobalModal() {
  const modal = document.getElementById("global-modal");
  if (!modal) return;

  const contentContainer = document.getElementById("modal-dynamic-content");
  const loader = modal.querySelector(".modal-loader");
  const closeBtn = modal.querySelector(".modal-close");
  const overlay = modal.querySelector(".modal-overlay");

  function openModal(content = null, isAjax = false, action = "", params = {}) {
    if (typeof window.lenis !== "undefined") {
      window.lenis.stop();
    }
    document.body.classList.add("modal-open");
    modal.classList.add("active");

    if (isAjax) {
      loadAjaxContent(action, params);
    } else if (content) {
      contentContainer.innerHTML = content;
    }
  }

  function closeModal() {
    modal.classList.remove("active");
    document.body.classList.remove("modal-open");
    
    if (typeof window.lenis !== "undefined") {
      window.lenis.start();
    }

    // Clear content after animation
    setTimeout(() => {
      contentContainer.innerHTML = "";
    }, 400);
  }

  function loadAjaxContent(action, params) {
    loader.classList.add("visible");
    contentContainer.innerHTML = "";

    const formData = new URLSearchParams();
    formData.append("action", action);
    for (const [key, value] of Object.entries(params)) {
      formData.append(key, value);
    }

    fetch("/wp-admin/admin-ajax.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData.toString(),
    })
      .then((response) => response.text())
      .then((html) => {
        loader.classList.remove("visible");
        contentContainer.innerHTML = html;
        // Trigger a custom event for any scripts that need to re-init
        document.dispatchEvent(new CustomEvent("modalContentColorLoaded"));
      })
      .catch((error) => {
        console.error("Modal AJAX Error:", error);
        loader.classList.remove("visible");
        contentContainer.innerHTML = "<p>Error loading content.</p>";
      });
  }

  // Event Listeners
  closeBtn.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("active")) {
      closeModal();
    }
  });

  // Global trigger listener
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-modal-trigger]");
    if (trigger) {
      e.preventDefault();
      const action = trigger.dataset.modalAction;
      const params = JSON.parse(trigger.dataset.modalParams || "{}");
      const contentId = trigger.dataset.modalContentId;

      if (action) {
        openModal(null, true, action, params);
      } else if (contentId) {
        const content = document.getElementById(contentId)?.innerHTML;
        openModal(content);
      }
    }
  });

  // Make available globally
  window.openGlobalModal = openModal;
  window.closeGlobalModal = closeModal;
}
